var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.textButtonClass,style:(_vm.textButtonStyle),on:{"click":_vm.onClick}},[(!_vm.loading)?_vm._t("default"):_c('svg-icon',{attrs:{"width":"25px","height":"25px","name":"three-dots","color":_vm.textColor}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }